import { ApChip } from '@alixpartners/ui-components';
import { FilterMenuContentDebounced } from 'components/NavFilter';
import {
	CounterWrapper,
	SmallSpinner,
	StyledMenu,
} from 'components/NavFilter/NavFilter.styles';
import React, { useState } from 'react';

const CategoryMultiSelect = props => {
	const {
		label,
		name,
		onChange,
		options,
		selected,
		disabled,
		isLoading,
	} = props;

	const [isOpen, setOpen] = useState(false);
	const [showVirtualList, setShowVirtualList] = useState(false);

	const toggleMenu = open => {
		setOpen(open);
	};
	const selectedCount = (selected && selected.length) || 0;
	return (
		<StyledMenu
			button={
				<div style={{ width: 'fit-content', position: 'relative' }}>
					{!!selectedCount && (
						<>
							<CounterWrapper>
								{isLoading ? (
									<SmallSpinner size={10} thickness={2} color="white" />
								) : (
									<>{selectedCount}</>
								)}
							</CounterWrapper>
						</>
					)}
					<ApChip small selected={isOpen || !!selectedCount}>
						{label || name}
					</ApChip>
				</div>
			}
			placement="bottom-start"
			toggleMenu={toggleMenu}
			isOpen={isOpen}
			isVirtualList={showVirtualList}
			disabled={disabled}
		>
			<FilterMenuContentDebounced
				setShowVirtualList={setShowVirtualList}
				options={options}
				onChange={onChange}
				selected={selected}
				isOpen={isOpen}
			/>
		</StyledMenu>
	);
};

export default CategoryMultiSelect;
